import { Header } from "./Components/Header";
import { Main } from "./Components/Main";
import { About } from "./Components/About";
import { History } from "./Components/History";
import { Program } from "./Components/Program";
import { Fqa } from "./Components/Fqa";
import { Team } from "./Components/Team";
import { Support } from "./Components/Support";
import { Gallery } from "./Components/Gallery";
import { Contact } from "./Components/Contact";

function App() {
  return (
    <>
    <Header/>
    <Main/>
    <About/>
    <History/>
    <Program/>
    <Gallery/>
    <Fqa/>
    <Team/>
    <Support/>
    <Contact/>
    </>
  );
}

export default App;
